const STATUS_STYLES = {
  open: "bg-sky-400/10 text-sky-300 border-sky-400/30",
  in_progress: "bg-gold/15 text-gold border-gold/40",
  review: "bg-violet-400/10 text-violet-300 border-violet-400/30",
  closed: "bg-emerald-400/10 text-emerald-300 border-emerald-400/30",
  paid: "bg-emerald-400/10 text-emerald-300 border-emerald-400/30",
  unpaid: "bg-white/5 text-[#D1D5DB] border-white/20",
  overdue: "bg-red-400/10 text-red-300 border-red-400/30",
  pending: "bg-gold/15 text-gold border-gold/40",
  completed: "bg-emerald-400/10 text-emerald-300 border-emerald-400/30",
  high: "bg-red-400/10 text-red-300 border-red-400/30",
  medium: "bg-gold/15 text-gold border-gold/40",
  low: "bg-white/5 text-[#9CA3AF] border-white/20",
};

export function StatusPill({ value, label, testId }) {
  const style = STATUS_STYLES[value] || "bg-white/5 text-[#D1D5DB] border-white/20";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wider ${style}`}
    >
      {label || String(value || "").replace(/_/g, " ")}
    </span>
  );
}

export function GoldProgress({ value = 0, testId, className = "" }) {
  return (
    <div className={`h-1.5 w-full rounded-full bg-white/10 overflow-hidden ${className}`} data-testid={testId}>
      <div
        className="h-full rounded-full bg-gradient-to-r from-gold-dark via-gold to-gold-soft transition-[width] duration-700"
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  );
}
